import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import Permissions from './FormPermission/Permissions';
import Report from './FormReport/Report';
import Setup from './FormSetup/Setup';
import TabBody from 'components/tab-components/TabBody';
import TabHeader from 'components/tab-components/TabHeader';
import TabLayout from 'components/tab-components/TabLayout';
import ExternalExport from './FormExternalExport/ExternalExport';
import { tabList } from './utils';
import { CallAPI } from 'actions/General';
// import FormDesign from './FormCreation/FormDesign';
import DesignForm from 'pages/form/DesignForm';
import Loader from 'components/common-components/Loader';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const AddForm = () => {
  const [formDetails, setFormDetails] = useState(null);
  const [dataSourcesOptionList, setDataSourcesOptionList] = useState([]);
  const [dataSourcesList, setFilterAbleDataSources] = useState([]);
  const [companyFieldList, setCompanyFieldList] = useState([]);
  const [companyFieldMap, setCompanyFieldMap] = useState([]);
  const [companyFieldDisplayValues, setCompanyFieldDisplayValues] = useState([]);
  const [folderList, setFolderList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(tabList[4]);
  const [isFormAdded, setIsFormAdded] = useState(true);
  const [formDetailLoading, setFormDetailLoading] = useState(false);
  const [dataSourceLoading, setDataSourceLoading] = useState(false);
  const [formInstructions, setFormInstructions] = useState(null);

  const filteredTabList = tabList.filter((tab) => {
    if (tab.title === 'tabs_permission') {
      return isPermissionAvailable(permissionKeys.field_work_form_permissions_read);
    }
    return true;
  });

  const location = useLocation();

  const getFormDetail = async (id, onlyForInstructions = false) => {
    const result = await CallAPI('GET_FORM_DETAIL', null, id, setFormDetailLoading, null, null);
    if (result.status) {
      if (onlyForInstructions) {
        setFormInstructions(result.data.formInstructions);
      } else {
        setIsFormAdded(false);
        setFormDetails(cloneDeep(result.data));
        setFormInstructions(result.data.formInstructions);
      }
    }
  };

  const getAllDataSources = async () => {
    const result = await CallAPI(
      'GET_ALL_DATA_SOURCES_FOR_FORMS',
      null,
      null,
      setDataSourceLoading,
      null,
    );
    if (result.status) {
      const dataSources = result.data
        .filter((dataSource) => !!dataSource.dataSourceSchema)
        .map((dataSource) => {
          const dataSourceColumns = dataSource.dataSourceSchema.map((column) => ({
            value: column.columnId,
            displayValue: column.columnName,
            type: column.dataType,
          }));
          return {
            value: dataSource._id,
            displayValue: dataSource.schemaName,
            columns: dataSourceColumns,
          };
        });

      setDataSourcesOptionList(dataSources);

      const dataSourcesFilters = result.data.filter((dataSource) => !!dataSource.dataSourceSchema);

      setFilterAbleDataSources(dataSourcesFilters);
    }
  };

  const getAllFolders = async () => {
    let result = await CallAPI('GET_ALL_FOLDERS', {}, null, null, null, null);
    if (result.status) {
      setFolderList(result.data);
    }
  };

  const fetchCompanyFieldList = async () => {
    const result = await CallAPI('GET_ALL_COMPANY_FIELDS', {}, null, null, null, null);
    if (result.status) {
      const fieldMap = {};
      const fieldList = [];
      const displayValues = {};

      result.data.forEach((item) => {
        fieldList.push({
          _id: item._id,
          fieldTitle: item.fieldTitle,
        });
        displayValues[item._id] = item.fieldTitle;

        const respectiveFieldOptions = [];
        let lastOption = null;
        item.dataSource.dataSourceSchema.forEach((col) => {
          if (item.dataSourceColumn === col.columnId) {
            lastOption = {
              value: col.columnId,
              displayValue: col.columnName,
              disabled: item.dataSourceColumn === col.columnId,
            };
          } else {
            respectiveFieldOptions.push({
              value: col.columnId,
              displayValue: col.columnName,
              columnType: col.dataType,
              disabled: item.dataSourceColumn === col.columnId,
            });
          }
          displayValues[col.columnId] = col.columnName;
        });
        if (lastOption) respectiveFieldOptions.push(lastOption);

        fieldMap[item._id] = {
          fieldColumn: item.dataSourceColumn,
          fieldOptions: respectiveFieldOptions,
        };
      });
      setCompanyFieldList(fieldList);
      setCompanyFieldMap(fieldMap);
      setCompanyFieldDisplayValues(displayValues);
    }
  };

  useEffect(() => {
    if (location && location.state && location.state.type === 'edit') {
      getFormDetail(location.state.formId);

      let selectedTabIndex = location.state.tab ? location.state.tab : 0;
      setSelectedTab(tabList[selectedTabIndex]);
    }
    getAllDataSources();
    getAllFolders();
    fetchCompanyFieldList();
  }, [location]);

  const updateTab = (selectedTabIndex) => {
    setSelectedTab(tabList[selectedTabIndex]);
  };
  return (
    <TabLayout>
      <TabHeader
        tabList={filteredTabList}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        disabledId={!isFormAdded ? [] : [1, 2, 3, 4]}
      />
      <TabBody transparent={[tabList[0].id].includes(selectedTab.id)}>
        {(formDetailLoading || dataSourceLoading) && (
          <Loader color='green-1' type='modal-spinner' />
        )}
        {selectedTab.id === tabList[0].id &&
          // <FormDesign
          //   formDetails={formDetails}
          //   getFormDetail={getFormDetail}
          //   dataSourcesList={dataSourcesOptionList}
          // />
          formDetails && (
            <DesignForm
              formDetails={formDetails ? formDetails : {}}
              getFormDetail={getFormDetail}
              formInstructions={formInstructions}
              dataSourcesList={dataSourcesOptionList}
              companyFieldList={companyFieldList}
              companyFieldMap={companyFieldMap}
              companyFieldDisplayValues={companyFieldDisplayValues}
            />
          )}
        {selectedTab.id === tabList[1].id && (
          <Report
            subTabs={selectedTab.subTabs}
            updateTab={updateTab}
            formDetails={formDetails}
            getFormDetail={getFormDetail}
          />
        )}
        {selectedTab.id === tabList[2].id && formDetails && (
          <Permissions
            formDetails={formDetails}
            updateTab={updateTab}
            getFormDetail={getFormDetail}
            dataSourcesList={dataSourcesList}
          />
        )}
        {selectedTab.id === tabList[3].id && formDetails && (
          <ExternalExport
            subTabs={selectedTab.subTabs}
            updateTab={updateTab}
            formDetails={formDetails}
            getFormDetail={getFormDetail}
          />
        )}
        {selectedTab.id === tabList[4].id && (
          <Setup
            formDetails={formDetails}
            updateTab={updateTab}
            getFormDetail={getFormDetail}
            companyFieldList={companyFieldList}
            folderList={folderList}
          />
        )}
      </TabBody>
    </TabLayout>
  );
};
export default AddForm;
